import { render, staticRenderFns } from "./dialog.pug?vue&type=template&id=6b53931d&lang=pug&"
import script from "./dialog.ts?vue&type=script&lang=ts&"
export * from "./dialog.ts?vue&type=script&lang=ts&"
import style0 from "./dialog.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports